import { useState } from "react";
import { Archive, ArchiveRestore } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

// BLOCK 173 Item 2 ,  shared admin Archive/Unarchive control. Used on the
// Opportunities list, Pending Review inbox, and the Detail page so the
// action and its confirmation copy stay identical everywhere.
//
// BLOCK 184 production defect follow-up ,  replaced window.prompt() /
// window.confirm() (a native popup that blocked the page and was easy to
// dismiss by accident) with the same inline reason field + confirm button
// pattern Reject already uses on this page.
export function ArchiveOpportunityButton({ oid, archived, onChanged, size = "sm" }) {
  const [busy, setBusy] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [reason, setReason] = useState("");
  const cls = size === "sm"
    ? "text-[11px] px-2.5 py-1"
    : "text-xs px-3 py-2";

  const doArchive = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/opportunities/${oid}/archive`, { reason: reason.trim() || null });
      toast.success("Opportunity archived.");
      setShowConfirm(false);
      setReason("");
      onChanged?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail?.message || "Archive failed");
    } finally {
      setBusy(false);
    }
  };

  const doUnarchive = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/opportunities/${oid}/unarchive`);
      toast.success("Opportunity restored.");
      onChanged?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail?.message || "Unarchive failed");
    } finally {
      setBusy(false);
    }
  };

  if (archived) {
    return (
      <button
        onClick={doUnarchive}
        disabled={busy}
        data-testid={`opp-unarchive-btn-${oid}`}
        className={`inline-flex items-center gap-1.5 rounded-sm border border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/10 transition disabled:opacity-50 ${cls}`}
      >
        <ArchiveRestore className="h-3.5 w-3.5" /> Unarchive
      </button>
    );
  }

  if (showConfirm) {
    return (
      <div className="flex flex-col items-end gap-1" data-testid={`opp-archive-confirm-${oid}`}>
        <input
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Reason for archive (optional)"
          data-testid={`opp-archive-reason-${oid}`}
          className="text-[11px] px-2 py-1 rounded-sm border border-amber-500/30 bg-black/40 w-56"
        />
        <div className="flex items-center gap-2">
          <button
            onClick={() => { setShowConfirm(false); setReason(""); }}
            disabled={busy}
            data-testid={`opp-archive-cancel-${oid}`}
            className="text-[10px] text-slate-500"
          >
            Cancel
          </button>
          <button
            onClick={doArchive}
            disabled={busy}
            data-testid={`opp-archive-confirm-btn-${oid}`}
            className={`inline-flex items-center gap-1.5 rounded-sm border border-amber-500/40 text-amber-300 hover:bg-amber-500/10 transition disabled:opacity-50 ${cls}`}
          >
            <Archive className="h-3.5 w-3.5" /> Confirm archive
          </button>
        </div>
      </div>
    );
  }

  return (
    <button
      onClick={() => setShowConfirm(true)}
      disabled={busy}
      data-testid={`opp-archive-btn-${oid}`}
      className={`inline-flex items-center gap-1.5 rounded-sm border border-amber-500/40 text-amber-300 hover:bg-amber-500/10 transition disabled:opacity-50 ${cls}`}
    >
      <Archive className="h-3.5 w-3.5" /> Archive
    </button>
  );
}

